export default {
    "name": "UpdateDashboardChartOptions",
    "kind": "HoudiniMutation",
    "hash": "d22729769352cfced883ef132eb1c1276e686344bde2fb757ea93fcd744022a7",

    "raw": `mutation UpdateDashboardChartOptions($input: UpdateDashboardReportInput!) {
  updateDashboardReport(input: $input) {
    chartMembership {
      chartId: id
      title
      showChart: display
      inReport
      supertype
      chartType: type
      id
    }
    chartEntries {
      id
      rank
      chart {
        id
      }
    }
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateDashboardReport": {
                "type": "DashboardReport",
                "keyRaw": "updateDashboardReport(input: $input)",

                "selection": {
                    "fields": {
                        "chartMembership": {
                            "type": "DashboardChartBase",
                            "keyRaw": "chartMembership",

                            "selection": {
                                "fields": {
                                    "chartId": {
                                        "type": "Int",
                                        "keyRaw": "chartId",
                                        "visible": true
                                    },

                                    "title": {
                                        "type": "String",
                                        "keyRaw": "title",
                                        "visible": true
                                    },

                                    "showChart": {
                                        "type": "Boolean",
                                        "keyRaw": "showChart",
                                        "visible": true
                                    },

                                    "inReport": {
                                        "type": "Boolean",
                                        "keyRaw": "inReport",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "supertype": {
                                        "type": "String",
                                        "keyRaw": "supertype",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "chartType": {
                                        "type": "String",
                                        "keyRaw": "chartType",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "chartEntries": {
                            "type": "DashboardChartEntry",
                            "keyRaw": "chartEntries",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "rank": {
                                        "type": "Int",
                                        "keyRaw": "rank",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "chart": {
                                        "type": "DashboardChartBase",
                                        "keyRaw": "chart",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "UpdateDashboardReportInput"
        },

        "types": {
            "UpdateDashboardReportChartMembership": {
                "chartId": "Int",
                "jsonOverride": "String",
                "rank": "Int"
            },

            "UpdateDashboardReportInput": {
                "charts": "UpdateDashboardReportChartMembership",
                "id": "Int",
                "json": "String",
                "name": "String",
                "shareId": "Int",
                "shareType": "DashboardReportShareType",
                "title": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=3b0ed68236c08778e70bd2dadead6291f99ae346891aeac5419ae4ea990d90c1";